import React from "react";
import "./SliderSkeleton.css";


const SliderSkeleton = () => {
    return (
        <div className="slider-skeleton-container">
            <div className="slider-skeleton">
                <div className="skeleton-image shimmer"></div>
                <div className="skeleton-caption shimmer" style={{ width: "70%" }}></div>
                <div className="skeleton-caption shimmer" style={{ width: "50%" }}></div>
            </div>
        </div>
    );
};

export default SliderSkeleton;
